namespace Marhaba {

    export class MarhabaSearchUnitCtrl {

        terminals: {};
        services: [string];
        minDate: Date;
        service: string;
        initial: any;

        /**
         * @param  {searchUnitService} private unit
         * @param  {broke} private broker
         * @param  {$log} private $log
         */
        constructor(
            private MarhabaSearchUnit: any, //Marhaba.MarhabaSearchUnit,
            private $scope: ng.IScope,
            private dateUtil
        ) {
            this.minDate = dateUtil.todayPlus(2, null, true);
            this.initial = null;
            this.services = this.MarhabaSearchUnit.services;
            this.service = this.MarhabaSearchUnit.service;
            this.processTerminals();

            $scope.$watch(() => this.service, (val) => {
                this.MarhabaSearchUnit.setService(val);
            });
        }

        /**
         * Setting date method for ngjs
         * @param  {Date} date
         */
        public setDate(date) {
            this.MarhabaSearchUnit.date = date;
        }

        public getDate() {
            return this.MarhabaSearchUnit.date;
        }

        private processTerminals() {
            this.MarhabaSearchUnit.terminals.then(
                terminals => this.terminals = terminals
            );
        }

        set terminal(value) {
            this.MarhabaSearchUnit.terminal = value;
        }

        get terminal() {
            return this.MarhabaSearchUnit.terminal;
        }

        setDeparture(value) {
            this.MarhabaSearchUnit.transfer = value;
        }

        setArrival(value) {
            this.MarhabaSearchUnit.transfer = value;
        }

        getAirport(value) {
            return this.MarhabaSearchUnit.transfer;
        }

        set occupancy(value) {
            this.MarhabaSearchUnit.occupancy = value;
        }

        get occupancy() {
            return this.MarhabaSearchUnit.occupancy;
        }

        set staffRates(value) {
            this.MarhabaSearchUnit.staffRates = value;
        }

        get staffRates() {
            return this.MarhabaSearchUnit.staffRates;
        }

        /**
         * Starting search
         */
        search() {
            var errors=this.MarhabaSearchUnit.search();
            this.$scope.$emit('flash:error', errors);
        }

    }

    angular
        .module('marhaba')
        .controller('MarhabaSearchUnitCtrl', MarhabaSearchUnitCtrl);

}
